// App.js 
import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import { AuthProvider } from './hooks';

function App() {

  useEffect(() => {
    const checkIconFontLoaded = () => {
      if (!window.iconfont) {
        const script = document.createElement('script');
        script.src = '/icons/iconfont.js';
        script.onload = () => { };
        document.body.appendChild(script);
      }
    };
    setTimeout(checkIconFontLoaded, 100);
  }, []);


  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;